import axios from "../../http/axios";
import {ATC_STATISTICS_FETCH_SUCCESSFULLY, DRUGS_PER_ATC_FETCH_SUCCESSFULLY} from "./actionTypes";

export const getATCCountriesCount = () => dispatch => {
    axios.get(`/drugs/anatomical-group-by-countries`)
        .then(data => {
            dispatch({
                type: ATC_STATISTICS_FETCH_SUCCESSFULLY,
                payload: data.data
            });
        });
};

export const getDrugsPerAtc = (countryCode) => dispatch => {
    const url = `/drugs/atc-tree-map`
    axios.get(url, {
        params: {
            countryCode: countryCode
        }
    }).then(data => {
        dispatch({
            type: DRUGS_PER_ATC_FETCH_SUCCESSFULLY,
            payload: data.data
        });
    });
};
